/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_SubtitlesInputs */



/**
* | output |
* | --- |
* | "Edit Subtitles" |
*
* @param {Edit_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_subtitles = /** @type {((inputs?: Edit_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier les sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel bearbeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактировать субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕を編集する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक संपादित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Editar legendas")
	return /** @type {LocalizedString} */ ("Edit Subtitles")
});